export const defaultReviews = [
  {
    name: 'Carrie',
    text: "Love this app!!! Every workout is challenging and I've had amazing results.",
  },
  {
    name: 'Laura',
    text: 'Beautiful, user friendly app. truly enjoying having quick access to workouts. makes reaching my goal of daily movement much easier.',
  },
  {
    name: 'Jess',
    text: 'Clear, strightforward, focused workouts that are enjoyable and effective.',
  },
];

export const defaultFaqs = [
  {
    question:
      'What makes this app different? How do I know it will work for me?',
    answer: `If you haven’t had success with other workout apps in the past, it’s understandable to be skeptical. But with the right guidance, support, and fresh content, you can achieve the results you want. Instead of static programs or PDFs with no assistance, this platform offers dynamic, interactive workouts. New programs and instructional videos are added regularly to keep you motivated and engaged. Plus, if you ever need help, you can reach out directly for questions, feedback, or to share your progress!`,
  },
  {
    question: 'I’m a beginner, is this for me?',
    answer: `No matter where you are in your fitness journey, this platform can help you succeed. Workouts and programs are designed for all fitness levels, with expert guidance every step of the way. You’ll be provided with easy-to-follow videos and clear instructions, ensuring you can perform each exercise safely and effectively.`,
  },
  {
    question: 'Do I need to purchase equipment?',
    answer: `It depends on the workout! Make sure to check out each program to see what is required to complete it. No matter what you have access to, there’s something for everyone to help you get in shape!`,
  },
];

export function toRawImgSrc(
  media?: null | { image?: string | null; cdn01?: string | null },
) {
  if (!media) return null;
  if (!media.image) return null;
  if (!media.cdn01) return media.image;

  return media.cdn01 + media.image;
}

export function toRawVideoSrc(
  media?: null | { video?: string | null; cdn01?: string | null },
) {
  if (!media) return null;
  if (!media.video) return null;
  if (!media.cdn01) return media.video;

  return media.cdn01 + media.video;
}

export function toImgSrc(
  media?: null | { image?: string | null; cdn01?: string | null },
) {
  if (!media) return null;
  if (!media.image) return null;
  if (!media.cdn01) return media.image;

  return encodeURI(media.cdn01 + media.image);
}

export function removeAlpha(hexColor: string, alpha = 1.0) {
  const a = Math.round(alpha * 255);
  const { r, g, b } = hexToRgb(hexColor);
  const [rb, gb, bb] = [r, g, b].map((x) =>
    Math.round(x * (a / 255) + 255 * (1 - a / 255)),
  );
  return rgbToHex(rb, gb, bb);
}

function rgbToHex(r: number, g: number, b: number) {
  return (
    '#' +
    [r, g, b]
      .map((x) => x.toString(16).padStart(2, '0'))
      .join('')
      .toUpperCase()
  );
}

function hexToRgb(hex: string) {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
      }
    : {};
}
